<template>
  <router-link :to="childFormOfSupportRoute" v-slot="{ href, navigate }" custom>
    <b-skeleton
      v-if="loader"
      type="button"
      animation="fade"
      variant="salmon-dark"
      width="100%"
      height="44px"
    >
    </b-skeleton>
    <b-button
      v-else
      :href="href"
      @click="navigate"
      class="font-weight-bold"
      variant="salmon-dark"
      size="lg"
      block
      pill
    >
      {{ $t('childPage.help') + helpText }}
      <i class="angle-right-icon ml-2 bg-white" style="height: 0.9rem"></i>
    </b-button>
  </router-link>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, type RouteLocationRaw } from 'vue-router'
import { useI18n } from 'vue-i18n'
import type { Maybe } from '@/types'

type Props = {
  name?: Maybe<string>
  loader?: Maybe<boolean>
}

const { t } = useI18n()
const route = useRoute()

const props = defineProps<Props>()

const helpText = computed<string>(() => {
  return props.name ?? t('childPage.childDenominator')
})

const childEditionId = computed<string | string[]>(() => {
  return route.params?.childEditionId
})

const childFormOfSupportRoute = computed<RouteLocationRaw>(() => {
  const name = 'FormOfSupport'
  return { name, params: { childEditionId: childEditionId.value } }
})
</script>
